<mat-list id="file-selection-list.{{idSuffix}}"
          class="file-selection-list text-align-left"
          cdkDropList
          cdkDropListSortingDisabled
          [cdkDropListData]="fileMetaList?.entries"
          [cdkDropListConnectedTo]="[cdkDropListConnectedTo]"
          [cdkDropListDisabled]="disabled"
          (cdkDropListDropped)="fileDropped($event)">
  <mat-list-item class="drag-drop-file-selection-list-item"
                 *ngFor="let file of fileMetaList?.entries; let i = index"
                 id="{{idPrefix}}item_{{i}}"
                 cdkDrag
                 [cdkDragDisabled]="file.not_selectable"
                 [cdkDragData]="{ file: file, category: category }"
                 [ngClass]="{ 'selected': isSelected(file.is_template ? file.id : file.link), 'disabled-item': file.not_selectable, 'disabled-list': disabled, 'last': i === fileMetaList.entries.length - 1 }"
                 (dblclick)="selectFile(file)">

    <i *ngIf="withIconAvatars && file.status === fileStatus.READY"
       matListAvatar
       class="dr-fa-icon far {{file.fileType.faClass}} fa-lg">
    </i>

    <i *ngIf="file.status === fileStatus.ERROR"
       matTooltip="{{ getErrorTitle(file) }}"
       matListAvatar
       class="dr-fa-icon far {{ fileType.XLS.faClass }} fa-lg iq-color-warn-light">
    </i>

    <mat-spinner matListAvatar *ngIf="file.status === fileStatus.LOADING" [diameter]="18"></mat-spinner>

    <h3 matLine [ngClass]="{ 'iq-color-warn-light': file.status === fileStatus.ERROR }"> {{ file.filename }} </h3>

  </mat-list-item>
</mat-list>
